import React, { useState } from 'react';
import { Navigation, FreeMode, Scrollbar, Keyboard, Mousewheel } from 'swiper/modules';
import cx from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import '../../../ui/accordions/Accordion/index.js';
import '../../../ui/accordions/AccordionSelect/index.js';
import '../../../ui/badges/Badge/index.js';
import '../../../ui/badges/BadgeIcon/index.js';
import '../../../ui/badges/Checked/index.js';
import '../../../ui/badges/Panel/index.js';
import '../../../ui/badges/Status/index.js';
import '../../../ui/badges/Tag/index.js';
import '../../../ui/buttons/BabyButton/Base.js';
import '../../../ui/buttons/BabyButton/variants/Chat/index.js';
import '../../../ui/buttons/BabyButton/variants/Menu/index.js';
import '../../../ui/buttons/BabyButton/variants/User/index.js';
import '../../../ui/buttons/BabyButton/variants/Vip/index.js';
import '../../../ui/buttons/BabyButton/variants/Wallet/index.js';
import { Button } from '../../../ui/buttons/Button/index.js';
import '../../../ui/buttons/CloseButton/index.js';
import '../../../ui/buttons/DirectionButton/index.js';
import '../../../ui/buttons/GradientButton/index.js';
import { GradientButtonV2 } from '../../../ui/buttons/GradientButtonV2/index.js';
import '../../../ui/buttons/TabButton/index.js';
import '../../../ui/buttons/TabButtonV2/index.js';
import '../../../ui/buttons/TimerButton/index.js';
import '../../../ui/buttons/TimerButtonV2/index.js';
import '../../../ui/buttons/TimerButtonV3/index.js';
import '../../../ui/loaders/Loader/index.js';
import '../../../ui/loaders/ScreenLoader/index.js';
import '../../../ui/modals/Modal/MobileWrapperV2/index.js';
import '../../../ui/modals/Modal/Modal.js';
import '../../../ui/modals/Modal/ModalContentWrapper/index.js';
import '../../../ui/popups/Popper/index.js';
import '../../../ui/popups/Popup/BasePopup/index.js';
import '../../../ui/popups/Popup/Thumb/index.js';
import '../../../ui/popups/Popup/ThumbV2/index.js';
import '../../../ui/popups/Popup/InfoTooltip/index.js';
import '../../../ui/sliders/EmblaCarousel/index.js';
import '../../../ui/tables/Table/index.js';
import '../../../ui/tables/Table/TableTd/index.js';
import '../../../ui/tabs/Tabs/index.js';
import '../../../ui/tabs/TabsV2/index.js';
import '../../../ui/texts/CryptoValue/index.js';
import '../../../ui/texts/AmountValue/index.js';
import '../../../ui/texts/TitleWithCurrency/index.js';
import '../../../ui/texts/Text/index.js';
import '../../../ui/texts/TextNavigation/index.js';
import '../../../ui/texts/MinValue/index.js';
import '../../../ui/socials/SocialsList/index.js';
import '../../../icons/ActivityIcon.js';
import '../../../icons/AgeIcon.js';
import '../../../icons/ArrowDownV2.js';
import '../../../icons/ArrowDownV3.js';
import '../../../icons/ArrowDown.js';
import '../../../icons/ArrowLeftBig.js';
import '../../../icons/ArrowLeft.js';
import '../../../icons/ArrowLeft2.js';
import '../../../icons/ArrowsDown.js';
import '../../../icons/ArrowsUp.js';
import '../../../icons/ArrowUpRightIcon.js';
import '../../../icons/Baccarat.js';
import '../../../icons/BlackJack.js';
import '../../../icons/BookIcon.js';
import '../../../icons/Calendar.js';
import '../../../icons/Carts.js';
import '../../../icons/ChartIcon.js';
import '../../../icons/ChainIcon.js';
import '../../../icons/CheckIcon2.js';
import '../../../icons/CheckIcon.js';
import '../../../icons/Checks.js';
import '../../../icons/ChevronDown.js';
import '../../../icons/Clock.js';
import '../../../icons/Close.js';
import '../../../icons/CoinsIcon.js';
import '../../../icons/Coins.js';
import '../../../icons/CopyIconDouble.js';
import '../../../icons/CopyIconFill.js';
import '../../../icons/Crown.js';
import '../../../icons/CryptoCurrency.js';
import '../../../icons/DiscordIcon.js';
import '../../../icons/DiscordIconV2.js';
import '../../../icons/Dota2.js';
import '../../../icons/Edit.js';
import '../../../icons/ExtendIcon.js';
import '../../../icons/EyeOff.js';
import '../../../icons/Eye.js';
import '../../../icons/FacebookIconV2.js';
import '../../../icons/FacebookIcon.js';
import '../../../icons/FiatCurrency.js';
import '../../../icons/FilterIcon.js';
import '../../../icons/GameIcon.js';
import '../../../icons/GameShows.js';
import '../../../icons/Game.js';
import '../../../icons/HeadPhones.js';
import '../../../icons/HomeIcon.js';
import '../../../icons/Horse.js';
import '../../../icons/InfoFill.js';
import '../../../icons/InfoIcon2.js';
import '../../../icons/InfoIcon.js';
import '../../../icons/InfoOutline.js';
import '../../../icons/LevelUp.js';
import '../../../icons/LinkIcon.js';
import '../../../icons/Link.js';
import '../../../icons/LiveCasino.js';
import '../../../icons/LiveIcons2.js';
import '../../../icons/LobbyIconV2.js';
import '../../../icons/LobbyIcon.js';
import '../../../icons/LogoSmallIcon.js';
import '../../../icons/Lock.js';
import '../../../icons/LOL.js';
import '../../../icons/MaxIcon.js';
import '../../../icons/MedalIcon.js';
import '../../../icons/MedalStarIcon.js';
import '../../../icons/MoneyBagIcon.js';
import '../../../icons/MoneyIcon.js';
import '../../../icons/MoneyRecive.js';
import '../../../icons/NewTwitterIcon.js';
import '../../../icons/OriginalsIcon.js';
import '../../../icons/Original.js';
import '../../../icons/PersonIcon.js';
import '../../../icons/PhoneChatIcon.js';
import '../../../icons/PhotoUp.js';
import '../../../icons/PlayIcon.js';
import '../../../icons/PlusIcon.js';
import '../../../icons/RainIcon.js';
import '../../../icons/RankIcon.js';
import '../../../icons/RankinIcon.js';
import '../../../icons/ReferalIcon.js';
import '../../../icons/RefreshIcon.js';
import '../../../icons/Reload.js';
import '../../../icons/Roulette.js';
import { Search2Icon } from '../../../icons/Search2Icon.js';
import '../../../icons/Search.js';
import '../../../icons/SendIcon.js';
import '../../../icons/Settings2.js';
import '../../../icons/SettingsV3.js';
import '../../../icons/Settings.js';
import '../../../icons/SlotsIcon2.js';
import '../../../icons/SlotsIcon.js';
import '../../../icons/SmileIcon.js';
import '../../../icons/SocialsIcon.js';
import '../../../icons/SortIcon.js';
import '../../../icons/SponsorshipIcon.js';
import '../../../icons/StarFill.js';
import '../../../icons/StarCraft.js';
import '../../../icons/StopIcon.js';
import '../../../icons/TableGamesIcon.js';
import '../../../icons/TelegramIcon.js';
import '../../../icons/TelegramIconV2.js';
import '../../../icons/TopPicksIcon.js';
import '../../../icons/Upload.js';
import '../../../icons/UserMoney.js';
import '../../../icons/UsersIconV2.js';
import '../../../icons/UsersIcon.js';
import '../../../icons/VerifiedIcon.js';
import '../../../icons/WalletAddIcon.js';
import '../../../icons/Wallet.js';
import '../../../icons/WarningIcon.js';
import '../../../icons/DeviceDesktop.js';
import '../../../icons/DeviceTablet.js';
import '../../../icons/DevicePhone.js';
import '../../../icons/ClockOrange.js';
import '../../../icons/CalendarOrange.js';
import '../../../icons/OpenLinkIcon.js';
import '../../../icons/FavoriteFill.js';
import '../../../icons/EditorChoiceV2.js';
import '../../../icons/ListBullet.js';
import '../../../icons/BankIcon.js';
import '../../../icons/ClockOrangeV2.js';
import '../../../icons/CalendarOrangeV2.js';
import '../../../icons/ReferralIconV2.js';
import '../../../icons/MoneyIconV2.js';
import '../../../icons/UsersIconV3.js';
import '../../../icons/InfoFillV2.js';
import '../../../icons/LockOrange.js';
import '../../../icons/LockV2.js';
import '../../../icons/AlertOrange.js';
import '../../../icons/LiveSupportV2.js';
import '../../../icons/Chat.js';
import '../../../icons/CrossCircle.js';
import '../../../icons/LockV3.js';
import '../../../icons/CoinCrypto.js';
import { useWindowSize } from '../../../../utils/hooks/useWindowSize.js';
import '../../../form/CheckBox/index.js';
import '../../../form/CodeInput/index.js';
import '../../../form/CryptoSelect/index.js';
import '../../../form/FileUploader/index.js';
import '../../../form/FormInput/index.js';
import '../../../form/FormSelect/index.js';
import '../../../form/PhoneInput/index.js';
import '../../../form/RadioButton/index.js';
import '../../../form/Select/index.js';
import '../../../form/SelectV2/index.js';
import '../../../form/SelectV3/index.js';
import '../../../form/SelectV4/index.js';
import { SearchInput } from '../../../form/Search/Input/index.js';
import '../../../form/Search/NoResults/index.js';
import '../../../form/Switch/index.js';
import '../../../form/DatePickerInput/index.js';
import NavigationLink from './NavButton/index.js';
import styles from './index.module.scss.js';

const NavigationBar = ({
  list = [],
  search = true,
  v2,
  navBarFullWidth = false,
  mobileSearch,
  searchClearButton,
  searchButtonType,
  onSearchClick = () => {
  },
  onLinkChange = () => {
  },
  onSearchValueChange = () => {
  },
  onMobileSearchClick = () => {
  },
  placeholder = "Search",
  forceMobileStyles,
  listAnimation = {
    "data-aos": "fade-up",
    "data-aos-delay": 200,
    "data-aos-duration": 1e3
  },
  searchAnimation = {
    "data-aos": "fade-up",
    "data-aos-delay": 200,
    "data-aos-duration": 1e3
  },
  ...props
}) => {
  const [activeLink, setActiveLink] = useState(list?.[0]?.id);
  const [str, setStr] = useState("");
  const { isMobile, isTablet } = useWindowSize();
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ...props,
      className: cx(styles.box, props.className, {
        [styles["mobile-styles"]]: forceMobileStyles,
        [styles["mobile-search"]]: mobileSearch
      })
    },
    !!list.length && /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles.list, {
          [styles.v2]: v2,
          [styles["mobile-search"]]: mobileSearch,
          [styles["with-search"]]: search,
          [styles["no-search"]]: !search,
          [styles["full-width"]]: navBarFullWidth
        }),
        ...listAnimation
      },
      /* @__PURE__ */ React.createElement(
        Swiper,
        {
          modules: [Navigation, FreeMode, Scrollbar, Keyboard, Mousewheel],
          spaceBetween: 4,
          slidesPerView: "auto",
          height: 60,
          slidesOffsetBefore: !v2 ? 2 : 0,
          slidesOffsetAfter: !v2 ? 2 : 16,
          onSlideChange: () => {
          },
          direction: "horizontal",
          onSwiper: () => {
          },
          freeMode: true,
          mousewheel: {
            thresholdDelta: 0.1,
            sensitivity: 10
          },
          onBeforeInit: (swiper) => {
            swiper.navigation.init();
            swiper.navigation.update();
          },
          onAfterInit: (swiper) => {
            swiper.navigation.init();
            swiper.navigation.update();
          },
          onResize: (swiper) => {
            swiper.navigation.init();
            swiper.navigation.update();
          },
          breakpoints: {},
          className: styles["swiper-box"]
        },
        list.map(({ icon, id, label }) => /* @__PURE__ */ React.createElement(SwiperSlide, { className: styles["swiper-slide"], key: id }, v2 ? /* @__PURE__ */ React.createElement(
          NavigationLink,
          {
            v2,
            active: id === activeLink,
            onClick: (v) => {
              setActiveLink(v);
              onLinkChange(v);
            },
            icon,
            id,
            label
          }
        ) : /* @__PURE__ */ React.createElement(
          GradientButtonV2,
          {
            active: id === activeLink,
            onClick: () => {
              setActiveLink(id);
              onLinkChange(id);
            },
            name: label,
            icon,
            v2: true
          }
        )))
      )
    ),
    (search && !isMobile && !isTablet || search && v2) && /* @__PURE__ */ React.createElement("div", { className: styles["search-box"], ...searchAnimation }, /* @__PURE__ */ React.createElement(
      SearchInput,
      {
        value: str,
        onChange: (event) => {
          if (event.target) {
            setStr(event.target.value);
            onSearchValueChange(event.target.value);
          } else {
            setStr(event);
            onSearchValueChange(event);
          }
        },
        className: styles.search,
        onSubmit: () => {
        },
        inputTheme: "blue",
        placeholder,
        clearButton: searchClearButton,
        buttonType: searchButtonType,
        onClick: onSearchClick
      }
    )),
    mobileSearch && !v2 && /* @__PURE__ */ React.createElement(
      Button,
      {
        text: "",
        onClick: onMobileSearchClick,
        size: "medium-3",
        themeKind: "dark-blue",
        className: styles["search-btn"],
        icon: /* @__PURE__ */ React.createElement(Search2Icon, null),
        ...searchAnimation
      }
    )
  );
};
NavigationBar.displayName = "NavigationBar";

export { NavigationBar };
//# sourceMappingURL=index.js.map
